module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/edf5571fc769a213bbbac59c1d03340f.png";